const { getElements } = window.BAO.Utils

class WishlistModal extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleExternalTrigger = this.handleExternalTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleCreate = this.handleCreate.bind(this)
    this.addToWishlist = this.addToWishlist.bind(this)

    this.checkLoggedIn = this.checkLoggedIn.bind(this)
    this.checkIsInWishlist = this.checkIsInWishlist.bind(this)

    this.handleSwitchList = this.handleSwitchList.bind(this)
    this.handleSwitchCreate = this.handleSwitchCreate.bind(this)

    this.listeners.add(document, 'click', this.handleExternalTrigger)
    this.listeners.add(this.els.submit.element, 'click', this.handleSubmit)

    this.listeners.add(this.els.create.element, 'click', this.handleCreate)

    this.listeners.add(
      this.els['switch-list'].element,
      'click',
      this.handleSwitchList,
    )
    this.listeners.add(
      this.els['switch-create'].element,
      'click',
      this.handleSwitchCreate,
    )

    this.populateVariants = this.populateVariants.bind(this)
    this.populateLists = this.populateLists.bind(this)

    this.handleVariantChange = this.handleVariantChange.bind(this)
    this.listeners.add(document, 'change', this.handleVariantChange)

    this.listeners.add(document, 'checkIsInWishlist', this.checkIsInWishlist)

    window.SwymCallbacks = window.SwymCallbacks || []
    window.SwymCallbacks.push((swat) => {
      this.checkLoggedIn()

      this.checkIsInWishlist()

      this.externalEls.trigger?.elements.forEach((el) => {
        el.setAttribute('data-wishlist-active', '')
      })
    })
  }

  checkLoggedIn () {
    if (this.hasAttribute('data-is-customer')) return

    /* eslint-disable no-console */
    window._swat.disconnectShopperContext(
      (onSuccess) => console.log('User cleared'),
      this.wishlistError,
    )
    /* eslint-enable */
  }

  handleClose () {
    window.drawers.activeDrawerKey = ''

    this.checkIsInWishlist()
  }

  async handleExternalTrigger (event) {
    const trigger = event.target.closest(
      '[data-wishlist-modal-external-el="trigger"]',
    )

    if (!trigger || !window._swat) return

    if (trigger.hasAttribute('data-wishlist-added')) {
      const lid = trigger.dataset.wishlistId

      const product = {
        epi: trigger.dataset.variantId,
        empi: trigger.dataset.productId,
        du: trigger.dataset.productUrl,
      }

      window._swat.deleteFromList(
        lid,
        product,
        this.checkIsInWishlist,
        this.wishlistError,
      )
    } else {
      this.els.title.element.innerHTML = trigger.dataset.productTitle
      this.els.material.element.innerHTML = trigger.dataset.productMaterial

      this.els.image.element.src = trigger.dataset.productImage

      window.drawers.activeDrawerKey = 'wishlist-add'

      this.populateVariants(
        `${trigger.dataset.productUrl}?variant=${trigger.dataset.variantId}`,
      )

      this.els.submit.element.setAttribute(
        'data-product-id',
        trigger.dataset.productId,
      )
      this.els.submit.element.setAttribute(
        'data-variant-id',
        trigger.dataset.variantId,
      )
      this.els.submit.element.setAttribute(
        'data-product-url',
        trigger.dataset.productUrl,
      )

      if (window._swat) {
        window._swat.fetchLists({
          callbackFn: this.populateLists,
          errorFn: this.wishlistError,
        })
      }
    }
  }

  handleVariantChange (e) {
    if (!this?.els?.['variants-select']?.exists) return

    if (e.target !== this.els['variants-select'].element) return

    this.els.submit.element.setAttribute(
      'data-variant-id',
      this.els['variants-select'].element.value,
    )
  }

  populateVariants (variant) {
    return window.BAO.sectionRenderer
      .fetchSingle('wishlist-variants', variant)
      .then((res) => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)
        const myself = newDOM.querySelector('.shopify-section')
        const selectDropdown = myself.querySelector(
          '[data-wishlist-modal-el="variants-select"]',
        )

        if (myself) {
          this.els.variants.element.innerHTML = myself.innerHTML

          if (selectDropdown) {
            this.els.submit.element.setAttribute(
              'data-variant-id',
              selectDropdown.value,
            )
          }
        }
      })
      .catch(() => {
        return null
      })
  }

  populateLists (lists) {
    this.els.lists.element.innerHTML = ''

    lists.forEach((list, index) => {
      this.els.lists.element.innerHTML += `<div class="wsh-Modal_Field">
        <input class="wsh-Modal_Radio" type="radio" id="list${
          list.lid
        }" name="wishlist_list" value="${list.lid}"${
          index === 0 ? ' checked' : ''
        }>
        <label class="wsh-Modal_Label fz-Body" for="list${list.lid}">${
          list.lname
        } (${list.cnt})</label>
      </div>`
    })

    if (lists.length === 0) {
      this.els['panel-create'].element.setAttribute('aria-hidden', false)
      this.els['panel-list'].element.setAttribute('aria-hidden', true)
      this.els['switch-list'].element.setAttribute('aria-hidden', true)
      this.els.newlist.element.value = 'My wishlist'
    } else {
      this.els['panel-create'].element.setAttribute('aria-hidden', true)
      this.els['panel-list'].element.setAttribute('aria-hidden', false)
      this.els['switch-list'].element.setAttribute('aria-hidden', false)
      this.els.newlist.element.value = ''
    }
  }

  handleSubmit () {
    const listChoice = getElements('[name="wishlist_list"]').find(
      (el) => el.checked,
    )

    this.addToWishlist(listChoice.value)
  }

  handleCreate () {
    const listConfig = {
      lname: this.els.newlist.element.value,
    }

    window._swat.createList(
      listConfig,
      (newList) => this.addToWishlist(newList.lid),
      this.wishlistError,
    )
  }

  handleSwitchList () {
    this.els['panel-create'].element.setAttribute('aria-hidden', true)
    this.els['panel-list'].element.setAttribute('aria-hidden', false)
  }

  handleSwitchCreate () {
    this.els['panel-create'].element.setAttribute('aria-hidden', false)
    this.els['panel-list'].element.setAttribute('aria-hidden', true)
  }

  addToWishlist (lid) {
    const product = {
      epi: parseInt(this.els.submit.element.dataset.variantId),
      empi: parseInt(this.els.submit.element.dataset.productId),
      du: this.els.submit.element.dataset.productUrl,
    }

    window._swat.addToList(lid, product, this.handleClose, this.wishlistError)
  }

  checkIsInWishlist () {
    if (window._swat) {
      window._swat.fetchLists({
        callbackFn: (lists) => {
          const productCount = lists.reduce(
            (accumulator, list) => accumulator + list.cnt,
            0,
          )
          this.externalEls.count.elements.forEach((countEl) => {
            countEl.setAttribute('aria-hidden', productCount === 0)
          })

          this.externalEls.trigger?.elements.forEach((el) => {
            let matchedVariant

            const matchedProduct = lists.find((list) =>
              list.listcontents.some((product) => {
                if (product.empi === parseInt(el.dataset.productId)) {
                  matchedVariant = product.epi
                  return true
                }
                return false
              }),
            )

            if (matchedProduct) {
              el.setAttribute('data-wishlist-added', '')
              el.setAttribute('data-wishlist-id', matchedProduct.lid)
              el.setAttribute('data-variant-id', matchedVariant)
            } else {
              el.removeAttribute('data-wishlist-added')
              el.removeAttribute('data-wishlist-id')
            }

            el.setAttribute('data-wishlist-active', '')
          })
        },
        errorFn: this.wishlistError,
      })
    }
  }

  wishlistError (errorMessage) {
    // eslint-disable-next-line
    console.log(`Wishlist error: ${errorMessage}`);
  }
}

if (!customElements.get('wishlist-modal')) {
  customElements.define('wishlist-modal', WishlistModal)
}
